import { GoodsMoveReq, InventorySupplementQuantityProps } from '../../types/inventory'
import React, { useContext, useEffect, useState } from 'react'
import { CommonContext } from '../common/context/commonContext'
import { Dialog } from 'primereact/dialog'
import { Button } from 'primereact/button'
import { InputNumber } from 'primereact/inputnumber'
import { useFormik } from 'formik'
import { number, object } from 'yup'
import { useTranslation } from 'react-i18next'
import { tokens } from 'locales/tokens'

const InventorySupplementQuantityDialog = (props: InventorySupplementQuantityProps) => {
    const { $http } = useContext(CommonContext)
    const { t } = useTranslation()

    const initialValues = {
        goodsQty: undefined,
    }
    const formik = useFormik({
        initialValues,
        validationSchema: object({
            goodsQty: number()
                .required(t(tokens.common.replenishment_quantity_is_required))
                .min(1, t(tokens.inventory.enter_minimum_move_qty_of_1_or_more)),
        }),
        onSubmit: async (data) => {
            let result = await $http().get(
                `/inventory/supplement/check-quantity/${props.inventorySupplementDetail.inventorySupplementDetailSeq}/${data.goodsQty}`,
            )
            if (result) {
                formik.resetForm()
                props.nextStep(data.goodsQty)
            } else {
                // false 를 내려주는 경우는 없음
            }
        },
    })

    const footer = () => {
        return (
            <form onSubmit={formik.handleSubmit}>
                <div className="flex justify-content-center">
                    <Button
                        className="col-3 p-button-secondary w-3"
                        label={t(tokens.common.close)}
                        size="small"
                        onClick={() => {
                            formik.resetForm()
                            return props.onHide && props.onHide(false)
                        }}
                    />
                    <Button className="col-3 bg-color-green border-color-green w-3" label={t(tokens.common.complete)} size="small" type="submit" />
                </div>
            </form>
        )
    }

    return (
        <Dialog
            header={<div className="required">{t(tokens.inventory.replenishment_qty)}</div>}
            visible={props.visible}
            onHide={() => props.onHide && props.onHide(false)}
            closable={false}
            className="w-10"
            headerClassName="text-primary pb-1"
            contentClassName="pb-0"
            footer={footer}
        >
            <div className="flex grid m-1 mb-3">
                <span className="mt-1 col-12">
                    <InputNumber
                        value={formik.values.goodsQty}
                        className="p-inputtext-md w-full"
                        placeholder={t(tokens.common.please_enter_the_quantity_to_replenish)}
                        maxFractionDigits={props.inventorySupplementDetail.gdslsUnitCd === 'KG' ? 1 : 0}
                        minFractionDigits={props.inventorySupplementDetail.gdslsUnitCd === 'KG' ? 1 : 0}
                        step={props.inventorySupplementDetail.gdslsUnitCd === 'KG' ? 0.1 : 1}
                        min={0}
                        onChange={(e) => formik.setFieldValue('goodsQty', e.value as number)}
                    />
                    {formik.errors.goodsQty ? (
                        <span className="ml-1 mt-1 text-red-600" style={{ fontSize: '12px' }}>
                            {formik.errors.goodsQty}
                        </span>
                    ) : null}
                </span>
            </div>
        </Dialog>
    )
}

export default InventorySupplementQuantityDialog
